var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(this.$route.name !== 'Login')?_c('Header'):_vm._e(),_c('div',{staticClass:"main-content"},[_c('router-view',{key:_vm.$route.fullPath})],1),(this.$route.name !== 'Login')?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }